import api from '../api';

export const authTokenURL = '/bookie/account/authz';
export const queryAuthToken = () =>
  api.get(authTokenURL).then((res) => res.data);
